export enum NumericComparison {
  isEqualTo = 0,
  isGreaterThan = 1,
  isLessThan = 2,
  isGreaterOrEqualTo = 3,
  isLessOrEqualTo = 4,
  isNotEqualTo = 5,
  isUpdated = 6,
  was = 7,
  wasNot = 8,
  isBlank = 9,
  isPresent = 10,
}